import "./App.css";
import Navbar from "./navbar/navbar";
import HeroSection from "./home/home";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutUs from "./About/About";
import Certificate from "./home/Certificate";
import Contact from "./Contact/Contact";
import International from "./international/international";
import Footer from "./home/Footer";

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      {/* Floating Contact Buttons */}
      <div className="floating-contact">
        <a
          href="https://wa.me/917351847736"
          target="_blank"
          rel="noreferrer"
          className="float-btn whatsapp"
        >
          💬
        </a>

        <a
          href="tel:+917351847736"
          className="float-btn call"
        >
          📞
        </a>

        <a
          href="mailto:sr.merchandiser@inlivin.com"
          className="float-btn email"
        >
          ✉
        </a>
      </div>

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/certification" element={<Certificate />} />
        <Route path="/international-fairs-media" element={<International />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;